import { c as _c } from "react/compiler-runtime";
import { ReactNode, useContext } from "react";
import { createPortal } from "react-dom";
import { FilterConfig } from "../../schemas";
import { FilterBarSlotContext } from "@/components/atoms/ContentContainer";
import { Plus, ListFilter } from "lucide-react";
import { FilterMenu } from "../../FilterMenu/FilterMenu";
import { ToolbarIconButton } from "@/components/organisms/TableToolbar/ToolbarIconButton";
import { FilterIndicator } from "../../FilterIndicator.tsx/FilterIndicator";
import { useDesktopFilters } from "./useDesktopFilters";
import { useTranslations } from "next-intl";
type Props = {
  filters: FilterConfig[];
  /** Show a badge with the active-filter count on the trigger button. */
  showCount?: boolean;
  trailingActions?: ReactNode;
  barPrefix?: ReactNode;
  hideClearAll?: boolean;
};
export function DesktopFilterOrchestrator(t0) {
  const $ = _c(36);
  const {
    filters,
    showCount,
    trailingActions,
    barPrefix,
    hideClearAll
  } = t0;
  const {
    filtersWithComputedValues,
    hasActiveFilters
  } = useDesktopFilters(filters);
  const t = useTranslations("common");
  const filterSlot = useContext(FilterBarSlotContext);
  let t1;
  if ($[0] !== filtersWithComputedValues) {
    t1 = filtersWithComputedValues.filter(_temp);
    $[0] = filtersWithComputedValues;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeCount = t1.length;
  let t2;
  if ($[2] !== filtersWithComputedValues) {
    t2 = () => filtersWithComputedValues.forEach(_temp2);
    $[2] = filtersWithComputedValues;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const clearAll = t2;
  let t3;
  if ($[4] !== filtersWithComputedValues || $[5] !== hasActiveFilters) {
    t3 = hasActiveFilters && filtersWithComputedValues.map(_temp3);
    $[4] = filtersWithComputedValues;
    $[5] = hasActiveFilters;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const indicators = t3;
  let t4;
  if ($[7] !== clearAll || $[8] !== filtersWithComputedValues || $[9] !== hideClearAll || $[10] !== indicators || $[11] !== t || $[12] !== trailingActions) {
    t4 = indicators && <div className="flex items-center gap-2"><div className="flex flex-wrap items-center gap-2">{indicators}</div><FilterMenu align="start" filters={filtersWithComputedValues} trigger={<button className="flex shrink-0 items-center justify-center size-6 rounded border border-border bg-card text-muted-foreground hover:bg-muted cursor-pointer"><Plus className="size-3" /></button>} />{!hideClearAll && <button onClick={clearAll} className="ml-auto shrink-0 px-1 text-xs text-muted-foreground hover:text-foreground cursor-pointer">{t("clearAll")}</button>}{trailingActions}</div>;
    $[7] = clearAll;
    $[8] = filtersWithComputedValues;
    $[9] = hideClearAll;
    $[10] = indicators;
    $[11] = t;
    $[12] = trailingActions;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const bar = t4;
  let t5;
  if ($[14] !== bar || $[15] !== barPrefix) {
    t5 = (barPrefix || bar) && <div className="flex flex-col gap-2 rounded-lg border border-border bg-card p-2">{barPrefix}{barPrefix && bar && <div className="-mx-2 h-px bg-border" />}{bar}</div>;
    $[14] = bar;
    $[15] = barPrefix;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const slotContent = t5;
  let t6;
  if ($[17] !== t) {
    t6 = t("filter");
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ListFilter className="size-4" />;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== activeCount || $[21] !== showCount) {
    t8 = showCount && activeCount > 0 && <span className="absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-medium text-primary-foreground">{activeCount}</span>;
    $[20] = activeCount;
    $[21] = showCount;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t6 || $[24] !== t8) {
    t9 = <ToolbarIconButton aria-label={t6} data-testid="advanced-filters-trigger" className="relative">{t7}{t8}</ToolbarIconButton>;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== filtersWithComputedValues || $[27] !== t9) {
    t10 = <FilterMenu align="end" filters={filtersWithComputedValues} trigger={t9} data-sentry-element="FilterMenu" data-sentry-source-file="DesktopFilterOrchestrator.tsx" />;
    $[26] = filtersWithComputedValues;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== filterSlot || $[30] !== indicators || $[31] !== slotContent) {
    t11 = slotContent && (filterSlot ? createPortal(slotContent, filterSlot) : <>{indicators}</>);
    $[29] = filterSlot;
    $[30] = indicators;
    $[31] = slotContent;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11) {
    t12 = <div className="flex gap-2 items-center" data-sentry-component="DesktopFilterOrchestrator" data-sentry-source-file="DesktopFilterOrchestrator.tsx">{t10}{t11}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
}
function _temp3(filter_1, index) {
  return <FilterIndicator key={index} {...filter_1} activeValues={filter_1.activeValues} inactiveValues={filter_1.inactiveValues} />;
}
function _temp2(filter_0) {
  return filter_0.onClear?.();
}
function _temp(filter) {
  return filter.activeValues.length > 0 || !!filter.activeLabel;
}